//list of skill filters 
export const skill = [
  {
    cat: 'Skill Level',
    key: 'Beginner',
    display: 'Beginner'
  },
  {
    cat: 'Skill Level',
    key: 'Intermediate',
    display: 'Intermediate'
  },
  {
    cat: 'Skill Level',
    key: 'Expert',
    display: 'Expert'
  }
]